/**
 * 应用监控接口
 */
import Axios from './axios.js'

export default {
	/*******************************************************************************************************************************JVM*/
	/*
	 * 获取最大内存
	 */
	getMaxMemory(success, failure) {
		Axios.get('/actuator/metrics/jvm.memory.max', {}, success, failure)
	},
	/*
	 * 获取可用内存
	 */
	getCommittedMemory(success, failure) {
		Axios.get('/actuator/metrics/jvm.memory.committed', {}, success, failure)
	},
	/*
	 * 获取已用内存
	 */
	getUsedMemory(success, failure) {
		Axios.get('/actuator/metrics/jvm.memory.used', {}, success, failure)
	},
	/*
	 * 获取缓冲区已用内存
	 */
	getUsedBufferMemory(success, failure) {
		Axios.get('/actuator/metrics/jvm.buffer.memory.used', {}, success, failure)
	},
	/*
	 * 获取缓冲区数
	 */
	getCountBuffer(success, failure) {
		Axios.get('/actuator/metrics/jvm.buffer.count', {}, success, failure)
	},
	/*
	 * 获取守护线程数
	 */
	getDaemonThreads(success, failure) {
		Axios.get('/actuator/metrics/jvm.threads.daemon', {}, success, failure)
	},
	/*
	 * 获取活跃线程数
	 */
	getLiveThreads(success, failure) {
		Axios.get('/actuator/metrics/jvm.threads.live', {}, success, failure)
	},
	/*
	 * 获取峰值线程数
	 */
	getPeakThreads(success, failure) {
		Axios.get('/actuator/metrics/jvm.threads.peak', {}, success, failure)
	},
	/*
	 * 获取加载classes数
	 */
	getLoadedClasses(success, failure) {
		Axios.get('/actuator/metrics/jvm.classes.loaded', {}, success, failure)
	},
	/*
	 * 获取未加载classes数
	 */
	getUnloadedClasses(success, failure) {
		Axios.get('/actuator/metrics/jvm.classes.unloaded', {}, success, failure)
	},
	/*
	 * GC耗时
	 */
	getPauseGC(success, failure) {
		Axios.get('/actuator/metrics/jvm.gc.pause', {}, success, failure)
	},
	/*******************************************************************************************************************************tomcat*/
	/*
	 * 获取tomcat最多活跃session数
	 */
	getMaxTomcatSessionsActive(success, failure) {
		Axios.get('/actuator/metrics/tomcat.sessions.active.max', {}, success, failure)
	},
	/*
	 * 获取错误总数
	 */
	getErrorTomcatGlobal(success, failure) {
		Axios.get('/actuator/metrics/tomcat.global.error', {}, success, failure)
	},
	/*
	 * 获取tomcat繁忙线程
	 */
	getBusyTomcatThreads(success, failure) {
		Axios.get('/actuator/metrics/tomcat.threads.busy', {}, success, failure)
	},
	/*
	 * 获取tomcat当前线程数（包括守护线程）
	 */
	getCurrentTomcatThreads(success, failure) {
		Axios.get('/actuator/metrics/tomcat.threads.current', {}, success, failure)
	},
	/*
	 * 获取tomcat配置的线程最大数
	 */
	getMaxTomcatThreadsConfig(success, failure) {
		Axios.get('/actuator/metrics/tomcat.threads.config.max', {}, success, failure)
	},
	/*******************************************************************************************************************************CPU*/
	/*
	 * 获取当前进程CPU使用率
	 */
	getUsageProcessCpu(success, failure) {
		Axios.get('/actuator/metrics/process.cpu.usage', {}, success, failure)
	},
	/*
	 * http请求调用情况 显示10个请求量最大，耗时最长的URL；统计非200的请求量
	 */
	getRequestsHttpServer(success, failure) {
		Axios.get('/actuator/metrics/http.server.requests', {}, success, failure)
	},
	/*
	 * 获取应用已运行时间
	 */
	getProcessUptime(success, failure) {
		Axios.get('/actuator/metrics/process.uptime', {}, success, failure)
	},
	/*
	 * 获取应用启动时间点
	 */
	getProcessStartTime(success, failure) {
		Axios.get('/actuator/metrics/process.start.time', {}, success, failure)
	},

}